export default "__VITE_ASSET__CCX5hU9M__"